var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45275 1H3C1.89543 1 1 1.89543 1 3V4.45275C1 5.55732 1.89543 6.45275 3 6.45275H4.45275C5.55732 6.45275 6.45275 5.55732 6.45275 4.45275V3C6.45275 1.89543 5.55732 1 4.45275 1Z",
    className: "fill stroke svg-orange  inverse",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7264 1H9.27368V6.45275H14.7264V1Z",
    className: "stroke fill-transparent svg-orange inverse",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 1H19.5471C18.4425 1 17.5471 1.89543 17.5471 3V4.45275C17.5471 5.55732 18.4425 6.45275 19.5471 6.45275H20.9999C22.1044 6.45275 22.9999 5.55732 22.9999 4.45275V3C22.9999 1.89543 22.1044 1 20.9999 1Z",
    className: "fill stroke svg-orange inverse",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45275 8.28076H1V13.7335H6.45275V8.28076Z",
    className: "stroke fill-transparent svg-orange inverse",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7264 8.28076H11.2737C10.1691 8.28076 9.27368 9.17619 9.27368 10.2808V11.7335C9.27368 12.8381 10.1691 13.7335 11.2737 13.7335H12.7264C13.831 13.7335 14.7264 12.8381 14.7264 11.7335V10.2808C14.7264 9.17619 13.831 8.28076 12.7264 8.28076Z",
    className: "fill stroke svg-orange inverse",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 8.28076H17.5471V13.7335H22.9999V8.28076Z",
    className: "stroke fill-transparent svg-orange inverse",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45275 15.5615H3C1.89543 15.5615 1 16.457 1 17.5615V19.0143C1 20.1188 1.89543 21.0143 3 21.0143H4.45275C5.55732 21.0143 6.45275 20.1188 6.45275 19.0143V17.5615C6.45275 16.457 5.55732 15.5615 4.45275 15.5615Z",
    className: "fill stroke svg-orange inverse",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7264 15.5615H9.27368V21.0143H14.7264V15.5615Z",
    className: "stroke fill-transparent svg-orange inverse",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 15.5615H19.5471C18.4425 15.5615 17.5471 16.457 17.5471 17.5615V19.0143C17.5471 20.1188 18.4425 21.0143 19.5471 21.0143H20.9999C22.1044 21.0143 22.9999 20.1188 22.9999 19.0143V17.5615C22.9999 16.457 22.1044 15.5615 20.9999 15.5615Z",
    className: "fill stroke svg-orange inverse",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps-icon.81e82933e72b016e80ccfefd05155b3c.svg";
export { ForwardRef as ReactComponent };